module.exports = __webpack_public_path__ + "img/sovit_slide2.1cd458cb.png";